import script from "./UsageFIU.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageFIU.vue?vue&type=script&setup=true&lang=js"

import "./UsageFIU.vue?vue&type=style&index=0&id=318ad003&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318ad003"]])

export default __exports__